import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import * as Action_App from '../actions/app'
import * as Action_User from '../actions/user'
import * as Action_Util from '../actions/util'

import {Icon, Button, NavBar, InputItem, List, TextareaItem, Flex, Modal} from 'antd-mobile'
import { createForm } from 'rc-form'

import RadioGroup from './app/appApply/RadioGroup'
const objectAssign = require('object-assign');

class AppApply extends React.Component {
    constructor(props) {
		super(props);
        const {actions,params} = props;
        actions.setScrollHeight(0.9);
        actions.getApp(params.id);
		actions.setSuccess(false);
    }
    componentDidMount() {
    	const {form,actions,orderFields} = this.props;
		const me = !!localStorage.me ? JSON.parse(localStorage.me) : {com:""};
		form.setFieldsValue(me.com=="other" ? 
			{c_id:me.member.ec_id,c_name:me.member.m_Comname,license:me.member.m_license} : 
			(me.com=="" ? {} : {c_name:!!orderFields.c_name ? orderFields.c_name.value : ""})
		);
	}
    render() {
        const {data,router,params,orderFields,actions,loading,licenses,success,scrollHeight} = this.props;
        const {app} = data;
        const { getFieldProps, getFieldError, validateFields, setFieldsValue} = this.props.form;
        const me = !!localStorage.me ? JSON.parse(localStorage.me) : {com:""};
        return (
            <div className="csm-body-wapper" >
                <NavBar onLeftClick={()=>{router.push('/app/' + params.id)}}> 
                   	应用申请
                </NavBar>
            	<form className="csm-scroll-wapper" style={{height:scrollHeight}}>
	            	{ me.com == '' ? 
	            		<List>
            				<InputItem clear 
            					{...getFieldProps('companyname',{
        							validateTrigger: ['onBlur','onChange'],
								    rules: [{ validator: this.checkNull.bind(this)}]
								})}
								error={!!getFieldError('companyname')}
								onErrorClick={() => {alert(getFieldError('companyname').join('、'))}}
            				>公司
					        </InputItem>
					        <InputItem clear
					        	{...getFieldProps('name',{
					        		validateTrigger: ['onBlur','onChange'],
								    rules: [{ validator: this.checkNull.bind(this)}]
								})}
					        	error={!!getFieldError('name')}
								onErrorClick={() => {alert(getFieldError('name').join('、'))}}
            				>姓名
					        </InputItem>
					        <InputItem clear
					        	{...getFieldProps('mail',{
					        		validateTrigger: ['onBlur','onChange'],
								    rules: [{ validator: this.checkMail.bind(this)}]
								})} 
								error={!!getFieldError('mail')}
								onErrorClick={() => {alert(getFieldError('mail').join('、'))}}
            				>邮箱
					        </InputItem>
					        <InputItem clear
					        	{...getFieldProps('mobile',{
					        		validateTrigger: ['onBlur','onChange'],
								    rules: [{ validator: this.checkPhoneNum.bind(this) }]
								})} 
								error={!!getFieldError('mobile')}
								onErrorClick={() => {alert(getFieldError('mobile').join('、'))}}
            				>手机号
					        </InputItem>
				    	</List>
				    :
				    <List>
				    	<InputItem clear placeholder="应用编码" editable={false} value={app.s_number}>应用编码</InputItem>
				        <InputItem clear placeholder="应用名称" editable={false} value={app.s_name}>应用名称</InputItem>
				        <InputItem clear placeholder="版本" editable={false} value={app.s_version}>版本</InputItem>
				        <InputItem {...getFieldProps('c_id')} style={{display:'none'}} />
					    <InputItem clear editable={!success} editable={false} value={!!orderFields.c_name ? orderFields.c_name.value : ""}
					    	extra={<Icon type="search" style={{width:'0.42rem',height:'0.42rem',paddingTop:'0.08rem'}} size='small' onClick={() => me.com == 'weaver' ? router.push('/customer/' + params.id) : ""}/>}
					    >客户</InputItem>
			        	<InputItem clear editable={!success}
				        	{...getFieldProps('c_name',{
				        		validateTrigger: ['onBlur','onChange'],
							    rules: [{ validator: this.checkNull.bind(this) }]
							})} 
							error={!!getFieldError('c_name')}
							onErrorClick={() => {alert(getFieldError('c_name').join('、'))}}
        				>授权用户
			        	</InputItem>
			        	<Flex className='am-list-item am-input-item' >
			        		<Flex.Item className='am-input-label' style={{flex:'none'}}>授权时间</Flex.Item>
					        <Flex.Item className='am-input-control csm-app-apply-radios'>
					        	<RadioGroup {...getFieldProps('type')} disabled={success || !orderFields.c_id} limit={app.s_freelimit == '1'}/>
					        </Flex.Item>
					    </Flex>   
			        	<TextareaItem clear editable={!success}
					        {...getFieldProps('license', {
					        	validateTrigger: ['onBlur','onChange'],
					        	rules: [{ validator: this.checkLicense.bind(this) }]
					        })}
					        title="标识码"
					        rows={6}
					        count
					        error={!!getFieldError('license')}
					        onErrorClick={() => {alert(getFieldError('license').join('、'))}}
					    />
				    </List>
	            	}
	            	<div style={{ margin: 30, textAlign: 'center'}}>
			            <Button type="primary" onClick={this.doSubmit.bind(this)} loading={window.location.hash.indexOf('/apply/') < 0 ? false : loading} disabled={success}>{success ? '已提交' : '提交'}</Button>
	        		</div>
            	</form>
	        </div>
        )
    }
    doSubmit(){
        const {validateFields,getFieldsValue} = this.props.form;
        const me = !!localStorage.me ? JSON.parse(localStorage.me) : {com:""};
        const {actions,app,data} = this.props;
    	validateFields((errors,values)=>{
    		if(!!errors){
				return
			}else{
				if(me.com == ""){
					values.type = '1';
					values.s_number  = data.app.s_number;
					values.s_name = data.app.s_name;
					actions.doRegister(values);
				}else{
					values.s_id = data.app.s_id;
					values.sw_id = data.app.sw_id;
					values.s_beta = data.app.s_beta;
					let params = {order: JSON.stringify(values)};
					params.access_token  = me.token.access_token;
					actions.doOrderSubmit(params);
				}
				
			}
    	});
    }
    checkLicense(rule, value, callback) {
		!!value ? (checkLicense(value) ? callback() : callback([new Error('license格式错误，多个license请用英文逗号隔开！')])) : callback([new Error('必填不能为空')]);
	}
	//申请意向表单验证
	checkNull(rule,value,callback){
		!!value ? callback() : callback([new Error('必填不能为空')]);
	}
	checkMail(rule,value,callback){
		!!value ? (checkMail(value) ? callback() : callback([new Error('请输入正确的邮箱')])) : callback([new Error('必填不能为空')]);
	}
	checkPhoneNum(rule,value,callback){
		!!value ? (checkPhoneNum(value) ? callback() : callback([new Error('请输入正确的电话号码')])) : callback([new Error('必填不能为空')]);
	}

} 

const checkMail = value => {
	return /^([a-z0-9_\-\.]+)@(([a-z0-9]+[_\-]?)\.)+[a-z]{2,3}$/.test(value)
}

const checkPhoneNum = value => {
	return /^(1(([3,8][0-9])|(4[5,7])|(5[^4])|(7[0,6,7,8])))\d{8}$/.test(value)
}

const checkLicense = license => {
	if(!license) return false;
	return license.split(",").every(el => {
		return /^[a-zA-Z0-9]{32}$/.test(el);
	});
}


function mapStateToProps(state) {
    const {app,util,user} = state;
    return {
    	scrollHeight: util.scrollHeight,
        loading: util.loading,
        data: app.data,
        orderFields: app.orderFields,
        licenses: app.licenses,
        success: user.success,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(objectAssign({},Action_App,Action_User,Action_Util), dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(createForm({
	onFieldsChange(props, fields){
		const orderFields = objectAssign({},props.orderFields,fields);
		props.actions.saveOrderFields(orderFields);
	},
	mapPropsToFields(props) {
		return props.orderFields;
  	}
})(AppApply));


// WEBPACK FOOTER //
// ./project/components/AppApply.js